import { mergeStyleSets } from '@fluentui/react';

const getStyles = (theme) =>
  mergeStyleSets({
    container: {
      width: '100%',
      height: '100%',
      padding: '24px',
    },
    textarea: {
      borderRadius: '6px',
      border: `1px solid ${theme.palette.gray3}`,
      outline: 'none',
      padding: '16px',
      fontSize: '1.25rem',
      minHeight: '56px',
      width: '100%',
      boxSizing: 'border-box',
    },
  });

export default getStyles;
